// TEMP_BRIDGE
require("./index" + ".tsx");

